import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import './PolicyMarketClearButton.css';
import {clearPolicyMarket, showToast} from "../../../redux/actions";
import {
  selectCurrentPlayer,
  selectIsInitiativeInterceptedWithIsolationism,
  selectNextInitiativePlayerId,
  selectPendingBuildings,
  selectPhase
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {PHASES} from "../../../constants/phases";
import {REGISTRY_SINGLETON} from "../../../scenes/Registry";
import {useIsCurrentUserTurn} from "../../../utils/gameState/user/useIsCurrentUserCurrentPlayer";
import ModalButton from "../../Modals/ModalWindow/ModalButton/ModalButton";
import {getNewPolicyMarket} from "../../../utils/policy/getNewPolicyMarket";
import {
  checkIfHasRemainingConstructionActions
} from "../../../utils/gameState/construction/checkIfHasRemainingConstructionActions";

const PolicyMarketClearButton = ({onClear}) => {
  const dispatch = useDispatch();
  const currentPlayer = useSelector(selectCurrentPlayer);
  const phase = useSelector(selectPhase);
  const pendingBuildings = useSelector(selectPendingBuildings);
  const nextInitiativePlayerId = useSelector(selectNextInitiativePlayerId);
  const isCurrentUserTurn = useIsCurrentUserTurn();
  const isInitiativeInterceptedWithIsolationism = useSelector(selectIsInitiativeInterceptedWithIsolationism);

  // Показываем кнопку только в фазе строительства
  if (!isCurrentUserTurn || phase !== PHASES.CONSTRUCTION) {
    return <ModalButton
      noSound={true}
      className={`policy-market-clear-button policy-market-clear-button_hidden`}
    >
      <h2>Обновить рынок</h2>
    </ModalButton>
  }

  const handleClick = () => {
    if (currentPlayer.isClearedPolicyMarketThisTurn) {
      dispatch(showToast('Нельзя обновлять рынок политик дважды в одном ходу!', 'warning', 5000));
      return;
    }

    if (!checkIfHasRemainingConstructionActions(currentPlayer, pendingBuildings, nextInitiativePlayerId, isInitiativeInterceptedWithIsolationism)) {
      dispatch(showToast('У Вас не осталось действий для обновления рынка политик!', 'warning', 5000));
      return;
    }

    if (onClear) {
      onClear();
    }
    REGISTRY_SINGLETON.getSoundManager().playClearPolicyMarket();
    dispatch(clearPolicyMarket(getNewPolicyMarket()));
  };

  let content
  let className;
  if (currentPlayer.isClearedPolicyMarketThisTurn) {
    content = <h2>Вы обновили рынок политик</h2>
    className = 'policy-market-clear-button_activated'
  } else {
    content = <>
      <h2>Обновить рынок за</h2>
      <img
        className="initiative-interception_button-last-img"
        src={`/img/icons/action.png`}
        alt={'Действие'}
        title={'Действие в Фазе Строительства'}
      />
    </>
  }

  return (
    <ModalButton
      onClick={handleClick}
      noSound={true}
      className={`policy-market-clear-button ${className}`}
    >
      {content}
    </ModalButton>
  )
};

export default PolicyMarketClearButton;
